import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Heart, Clock, MapPin, MessageCircle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="5677" id="treatment-hero" className="bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background/90 z-10" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/radiant-smile.png)] bg-cover bg-right md:bg-center bg-no-repeat opacity-20 mix-blend-multiply transition-transform duration-[10000ms] hover:scale-110" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 md:px-8 flex flex-col items-center text-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="mb-8 inline-flex items-center gap-2 rounded-none bg-primary/5 px-6 py-2 text-sm font-medium text-primary tracking-[0.2em] backdrop-blur-sm border-b border-primary/30">
          <ShieldCheck className="h-4 w-4" />
          <span>ESTETİK DİŞ HEKİMLİĞİ</span>
        </div>

        {}
        <h1 className="max-w-5xl text-6xl md:text-[84px] font-serif font-light tracking-widest text-foreground mb-6 leading-[1.1]">
          <span className="text-primary italic">Hollywood</span>{" "}
          Smile Tasarımı
        </h1>

        {}
        <p className="max-w-3xl text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed font-sans border-t border-primary/20 pt-8">Kusursuz bir gülüş, özgüvenin anahtarıdır. Modern diş hekimliği teknikleri ve kişiye özel dijital tasarım protokolleriyle, hayalinizdeki doğal ve ışıltılı gülüşe güvenli şekilde kavuşmanızı sağlıyoruz.</p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-gradient-to-r from-primary to-[#8e7341] hover:opacity-90 text-primary-foreground rounded-none px-12 py-8 text-lg shadow-lg border-none tracking-widest">
            <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab className="block w-full">
              <MessageCircle className="mr-2 h-5 w-5" />
              RANDEVU AL
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="bg-transparent border-primary/50 text-foreground hover:bg-primary hover:text-white rounded-none px-12 py-8 text-lg transition-all duration-300 tracking-widest">
            
          </Button>
        </div>

        {}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-6 w-full max-w-5xl">
          {[{
          icon: Heart,
          title: "Kişiye Özel Tasarım",
          desc: "Yüz hatlarınıza ve karakterinize en uygun gülüş formu"
        }, {
          icon: Clock,
          title: "Hızlı Dönüşüm",
          desc: "Minimum sürede maksimum estetik ve fonksiyonel sonuçlar"
        }, {
          icon: MapPin,
          title: "Modern Teknoloji",
          desc: "Dijital ölçü ve 3D tasarım sistemleri ile hatasız uygulama"
        }].map((feature, i) => <div key={i} data-index={i} className="bg-card/40 backdrop-blur-sm border border-border/50 rounded-none p-8 flex flex-col items-center hover:bg-accent/50 transition-colors duration-300 group">
              <feature.icon className="h-10 w-10 text-primary mb-4 transition-transform duration-300 group-hover:scale-110" />
              <h3 className="text-lg font-serif font-medium text-foreground mb-2 tracking-wide">
                {feature.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{feature.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}